"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var FilterBar_1 = __importDefault(require("../common/table/FilterBar"));
var use_stores_1 = require("hooks/use-stores");
var use_dialog_1 = require("hooks/use-dialog");
var use_notification_1 = require("hooks/use-notification");
var TableHeading_1 = require("../common/table/TableHeading");
var utils_1 = require("../../util/utils");
var Pager_1 = __importDefault(require("../common/table/Pager"));
var ClientsTable_1 = __importDefault(require("./ClientsTable"));
var ClientsAddBand_1 = __importDefault(require("./ClientsAddBand"));
var Dialog_1 = require("../Dialog");
var Notification_1 = require("../Notification");
var Clients = mobx_react_1.observer(function () {
    var _a = use_stores_1.useStores(), prefsStore = _a.prefsStore, clientStore = _a.clientStore;
    var _b = react_1.useState(false), transition = _b[0], setTransition = _b[1];
    var _c = react_1.useState(0), offset = _c[0], setOffset = _c[1];
    var prefs = prefsStore.data.clientsTable;
    var perPage = prefs.perPage;
    var transitionTimeout = react_1.useRef(null);
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    var search = function (searchValue) {
        var regEx = new RegExp(searchValue.trim(), 'gi');
        var searchArray = [];
        for (var _i = 0, _a = clientStore.data; _i < _a.length; _i++) {
            var client = _a[_i];
            if (regEx.test(client.clientName) ||
                regEx.test(client.websiteUrl)) {
                searchArray.push(client);
            }
        }
        return searchArray;
    };
    var _d = react_1.useState(prefs.search.length > 0), useSearch = _d[0], setUseSearch = _d[1];
    var _e = react_1.useState(useSearch ? search(prefs.search) : []), searchResults = _e[0], setSearchResults = _e[1];
    var sortData = function (name, direction) {
        if (name === void 0) { name = null; }
        if (direction === void 0) { direction = TableHeading_1.TableDirections.UP; }
        var sortType = { name: name, direction: direction };
        if (sortType.name === null) {
            return [];
        }
        var sortName = sortType.name.toLowerCase();
        if (sortName === 'name')
            sortName = 'clientName';
        if (sortName === 'website url')
            sortName = 'websiteUrl';
        var sortDirection = sortType.direction;
        var ogArray = useSearch ? searchResults : clientStore.data;
        return ogArray.slice().sort(function (a, b) {
            var aSort = a[sortName];
            var bSort = b[sortName];
            if (aSort < bSort)
                return sortDirection === TableHeading_1.TableDirections.UP ? -1 : 1;
            if (aSort > bSort)
                return sortDirection === TableHeading_1.TableDirections.UP ? 1 : -1;
            return 0;
        });
    };
    var _f = react_1.useState(prefs.sort.name !== null), useSort = _f[0], setUseSort = _f[1];
    var _g = react_1.useState(useSort ? sortData(prefs.sort.name, prefs.sort.direction) : []), sortResults = _g[0], setSortResults = _g[1];
    react_1.useEffect(function () {
        document.title = 'RWD Admin - Clients';
        if (!clientStore.data || clientStore.data.length <= 0) {
            api_1.default.getClients()
                .then(function (response) { return clientStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    var perPageHandler = function (value) {
        prefsStore.editData({
            clientsTable: __assign(__assign({}, prefs), { perPage: value })
        });
    };
    var searchHandler = function (value) {
        prefsStore.editData({
            clientsTable: __assign(__assign({}, prefs), { search: value })
        });
        var searchClients = search(value);
        if (searchClients.length >= 0) {
            setSearchResults(searchClients);
            setOffset(0);
        }
        setUseSearch(value.length >= 0);
    };
    var sortHandler = function (name, direction) {
        prefsStore.editData({
            clientsTable: __assign(__assign({}, prefs), { sort: {
                    name: name,
                    direction: direction
                } })
        });
        if (name !== null) {
            setSortResults(sortData(name, direction));
        }
        setUseSort(name !== null);
    };
    var pageHandler = function (page) {
        var max = Math.ceil(clientStore.data.length / perPage) - 1;
        if (page === offset)
            return;
        if (offset === max && page >= max)
            return;
        if (offset === 0 && page <= 0)
            return;
        setTransition(true);
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            setTransition(false);
            setOffset(utils_1.clamp(0, page, max));
        }, 200);
    };
    var deleteHandler = function (client) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Delete " + client.clientName + "?",
            description: 'Are you sure you want to delete this client?'
        })
            .then(function () {
            api_1.default.deleteClient(client)
                .then(function () {
                clientStore.removeDataItem(client);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Client was deleted'
                });
            }).catch(api_1.catchHandler);
        });
    };
    var currentPage = offset * perPage;
    return (react_1.default.createElement("div", { className: 'page thin-scroll clients', "data-transition": transition },
        react_1.default.createElement(ClientsAddBand_1.default, null),
        react_1.default.createElement(FilterBar_1.default, { label: 'Clients', perPage: perPage, onPerPageChange: perPageHandler, searchValue: prefs.search, onSearchChange: searchHandler }),
        react_1.default.createElement(ClientsTable_1.default, { sort: prefs.sort, data: useSearch &&
                searchResults.slice(currentPage, currentPage + perPage) ||
                useSort &&
                    sortResults.slice(currentPage, currentPage + perPage) ||
                clientStore.data.slice(currentPage, currentPage + perPage), onChangeSort: sortHandler, onDelete: deleteHandler }),
        react_1.default.createElement(Pager_1.default, { itemsLength: useSearch ?
                searchResults.length === 0 ? 0 : searchResults.length :
                useSort ?
                    sortResults.length === 0 ? 0 : sortResults.length :
                    clientStore.data.length, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler })));
});
exports.default = Clients;
